/* @flow */

import * as React from 'react';
import { useCallback, useMemo, useRef } from 'react';

import type { ModalState } from '../../../redux/modal/reducers';

import Localizer from '../../../helpers/localization';
import ProfilesManager from '../../../helpers/profiles/profilesManager';
import Avatar from '../../profiles/Avatar';
import Modal, { ModalView } from '../modal';
import './ProfileAvatarSelectModal.css';

const ProfileAvatarSelectModal = ({ initialAvatarId, modalId, selectedAvatarId }: ModalState): React.Node => {
  const modalRef = useRef<ModalView | null>(null);

  const avatarIds = useMemo<Array<string>>(() => ProfilesManager.avatarIds);
  const usedAvatarIds = useMemo<Set<string>>(() => {
    const ids = ProfilesManager.getUsedAvatarIds();

    if (initialAvatarId) {
      // Remove initial avatar Id to allow its selection
      ids.delete(initialAvatarId);
    }

    return ids;
  });

  const setModalRef = useCallback((instance: ModalView | null) => {
    modalRef.current = instance;
  }, []);

  const close = useCallback((avatarId: string | null) => {
    modalRef.current?.close(avatarId);
  }, []);

  return (
    <Modal
      ariaLabel={Localizer.localize('accessibility.modal.profile_avatar_selection')}
      className='profileAvatarSelect'
      header={Localizer.localize('profiles.avatar_selection.title')}
      innerRef={setModalRef}
      modalId={modalId}
    >
      <div className='avatarSelectContainer'>
        {avatarIds.map((avatarId, i) => (
          <Avatar
            aria-label={Localizer.localize('accessibility.profiles.select_avatar_by_index', { index: i + 1 })}
            avatarId={avatarId}
            isSelected={avatarId === selectedAvatarId}
            isUnavailable={usedAvatarIds.has(avatarId)}
            key={avatarId}
            onClick={close}
          />
        ))}
        {/*<Avatar avatarId={null} isSelected={selectedAvatarId === null} onClick={close} />*/}
      </div>
    </Modal>
  );
};

export default ProfileAvatarSelectModal;
